import { Link, useLocation } from "react-router-dom";

interface SiteNavProps {
  variant?: "light" | "dark";
}

export default function SiteNav({ variant = "light" }: SiteNavProps) {
  const location = useLocation();

  const links = [
    { label: "Try", to: "/try" },
    { label: "Demo", to: "/demo" },
    { label: "Get in Touch", to: "/contact" },
  ];

  const isDark = variant === "dark";

  return (
    <header
      className={`w-full px-6 md:px-10 pt-6 md:pt-8 ${
        isDark ? "text-background-50" : "text-foreground-800"
      }`}
    >
      <nav className="flex items-center justify-between">
        {/* Logo mark */}
        <Link
          to="/"
          className="flex items-center gap-2 group cursor-pointer"
          aria-label="Topbud home"
        >
          <span
            className={`w-6 h-6 rounded-full block transition-transform duration-300 group-hover:scale-110 ${
              isDark ? "bg-background-50" : "bg-primary-500"
            }`}
          />
        </Link>

        {/* Right nav */}
        <ul
          className={`flex items-center gap-4 md:gap-6 font-label text-[11px] md:text-[12px] tracking-[0.18em] uppercase ${
            isDark ? "text-background-50/80" : "text-foreground-800"
          }`}
        >
          {links.map((link, index) => {
            const active = location.pathname === link.to;
            return (
              <li key={link.label} className="flex items-center gap-4 md:gap-6">
                <Link
                  to={link.to}
                  className={`cursor-pointer whitespace-nowrap transition-colors duration-200 flex items-center gap-2 ${
                    isDark
                      ? "hover:text-background-50"
                      : "hover:text-foreground-950"
                  } ${active ? (isDark ? "text-background-50" : "text-foreground-950") : ""}`}
                >
                  {active && (
                    <span
                      className={`w-1.5 h-1.5 rounded-full ${
                        isDark ? "bg-accent-400" : "bg-accent-500"
                      }`}
                    />
                  )}
                  <span>{link.label}</span>
                </Link>
                {index < links.length - 1 && (
                  <span
                    className={`select-none ${
                      isDark ? "text-background-50/30" : "text-foreground-300"
                    }`}
                  >
                    /
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </header>
  );
}